export const ACTUALIZAR_LIST_TAREASXPROCEDIMIENTO = "ACTUALIZAR_LIST_TAREASXPROCEDIMIENTO";
export const MODIFICAR_TAREASXPROCEDIMIENTO = "MODIFICAR_TAREASXPROCEDIMIENTO";
export const AGREGAR_TAREASXPROCEDIMIENTO = "AGREGAR_TAREASXPROCEDIMIENTO";  
export const ELIMINAR_TAREASXPROCEDIMIENTO = "ELIMINAR_TAREASXPROCEDIMIENTO";